/*============================================================================
  GWP / Promoción VIP
  ----------------------------------------------------------------------------
  Agrega y quita el producto de regalo del carrito. El descuento que lo pone
  en $0 es un Buy X Get Y de Shopify Admin y es un mecanismo aparte: este
  archivo nunca intenta modificar precios. Shopify tampoco agrega nada al
  carrito por su cuenta — ni con código ni automático — y de ahí que exista
  todo esto.

  Dos modos, según el checkbox "Public mode" de Personalizar tema: 

    - apagado: el regalo sólo aplica a quien llega con ?gwp=<param> en la URL.
      El resto del tráfico no paga nada: salimos antes de pedir el carrito.
    - prendido: aplica a todos. No hay nada que verificar sobre el origen del 
      visitante, así que el script corre completo en cada sesión.  

  IMPORTANTE — esta tienda usa UpCart, no el carrito del tema.
  UpCart intercepta el click de add to cart con stopImmediatePropagation(),
  así que el handler del tema nunca corre y Shopify.theme.ajaxCart.updateView
  nunca se llama en un add desde el PDP. Por eso NO dependemos de un solo
  enganche: reconciliamos desde varias fuentes independientes, con debounce,
  y reconcile() es idempotente (si el carrito ya está correcto, no escribe).
 
  Fuentes que disparan la reconciliación:
    1. Eventos públicos de UpCart (aftersell-upcart:public-events:*). Son
       CustomEvents en window, así que los escuchamos por nombre y no hay
       dependencia de que UpCart ya haya cargado.
    2. Click en cualquier add to cart, en fase de captura para correr antes
       del stopImmediatePropagation() de UpCart.
    3. El updateView del tema, que sigue cubriendo la página de carrito y
       cualquier ruta que UpCart no intercepte.
    4. Lectura de /cart.js al cargar la página.

  El interceptor de fetch de UpCart es un observador puro: pasa los
  argumentos sin modificarlos y sólo inspecciona la URL, así que la line item
  property _gwp de nuestro add llega intacta.

  DEBUG: en producción no escribe nada en consola. Para encenderlo agrega
  gwp_debug=1 a la URL; queda encendido el resto de la sesión y expone
  window.GWP con state(), reset() y clearCart(). Se apaga con gwp_debug=0.
==============================================================================*/
(function () {
  'use strict';

  /*==========================================================================
    sessionStorage — puede lanzar en modo privado de Safari o con cookies
    bloqueadas. Sin él la promoción simplemente no se activa, que es el modo
    de falla correcto.
  ==========================================================================*/

  function readFlag(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeFlag(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* sin sessionStorage no hay promoción */
    }
  }

  function clearFlag(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      /* sin sessionStorage no hay promoción */
    }
  }

  function urlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (error) {
      return null;
    }
  }

  /*==========================================================================
    Debug
  ==========================================================================*/

  var DEBUG_KEY = 'gwp:debug';
  var debugParam = urlParam('gwp_debug');

  if (debugParam === '1') writeFlag(DEBUG_KEY, '1');
  if (debugParam === '0') clearFlag(DEBUG_KEY);

  // El param de la URL manda por sí solo, sin pasar por sessionStorage. Si
  // guardáramos el debug únicamente en sessionStorage, entonces cuando
  // sessionStorage es justo lo que está roto el debug no podría encenderse y
  // en lugar de un diagnóstico saldría silencio, que es el peor caso posible.
  var DEBUG = debugParam === '1' || (debugParam !== '0' && readFlag(DEBUG_KEY) === '1');

  function log(message, detail) {
    if (!DEBUG || typeof console === 'undefined' || !console.log) return;
    if (arguments.length > 1) console.log('[gwp] ' + message, detail);
    else console.log('[gwp] ' + message);
  }

  /*==========================================================================
    Configuración
  ==========================================================================*/

  // sessionStorage es la única dependencia dura de la promoción: sin él no
  // podemos recordar que la sesión vino de la campaña. Si no sirve, hay que
  // decirlo, porque el resto del flujo se ve idéntico a "no pasó nada".
  function storageWorks() {
    try {
      sessionStorage.setItem('gwp:probe', '1');
      sessionStorage.removeItem('gwp:probe');
      return true;
    } catch (error) {
      return false;
    }
  }

  if (!storageWorks()) {
    log('sessionStorage NO está disponible (modo privado, cookies bloqueadas o una extensión). La promoción no puede activarse en esta sesión.');
  }

  var configElement = document.getElementById('gwp-config');

  if (!configElement) {
    log('no hay #gwp-config: la promo está apagada o mal configurada en Personalizar tema');
    return;
  }

  var config;

  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    log('#gwp-config no es JSON válido', error);
    return;
  }

  var PARAM = config.param;
  var VARIANT_ID = config.variant_id;
  var QUALIFYING_IDS = config.qualifying_ids || [];
  var GIFT_PRODUCT_ID = config.product_id;
  var PUBLIC = config.public === true;

  log('config', config);

  if (!PARAM || !VARIANT_ID || !QUALIFYING_IDS.length) {
    log('config incompleta: falta param, variante del regalo, o productos que califican');
    return;
  }

  var PROPERTY = '_gwp';
  var MAX_FAILURES = 3;

  var FLAG_KEY = 'gwp:flag:' + PARAM;
  var ADDED_KEY = 'gwp:added:' + PARAM;
  var OPT_OUT_KEY = 'gwp:optout:' + PARAM;
  var FAILURES_KEY = 'gwp:failures:' + PARAM;
  var NO_DISCOUNT_KEY = 'gwp:nodiscount:' + PARAM;

  /*==========================================================================
    Deadline y tope de fallos
  ==========================================================================*/

  var deadline = null;

  if (config.deadline) {
    var parsedDeadline = Date.parse(config.deadline);
    if (isNaN(parsedDeadline)) log('deadline no se pudo parsear, se ignora: ' + config.deadline);
    else deadline = parsedDeadline;
  }

  function expired() {
    return deadline !== null && Date.now() > deadline;
  }

  function failureCount() {
    return parseInt(readFlag(FAILURES_KEY), 10) || 0;
  }

  function recordFailure() {
    writeFlag(FAILURES_KEY, String(failureCount() + 1));
    syncMessages();
  }

  // Corta el reintento después de MAX_FAILURES para que un producto agotado o
  // un error de red no dispare una petición en cada mutación del carrito.
  function givenUp() {
    return failureCount() >= MAX_FAILURES;
  }

  function state() {
    return {
      param: PARAM,
      public: PUBLIC,
      flag: readFlag(FLAG_KEY),
      added: readFlag(ADDED_KEY),
      optOut: readFlag(OPT_OUT_KEY),
      noDiscount: readFlag(NO_DISCOUNT_KEY),
      failures: failureCount(),
      deadline: config.deadline,
      expired: expired(),
      giftVariantId: VARIANT_ID,
      qualifyingIds: QUALIFYING_IDS
    };
  }

  /*==========================================================================
    Activación por parámetro de URL
  ==========================================================================*/

  if (expired()) {
    log('promo expirada el ' + config.deadline + ', no hago nada');
    return;
  }

  var incoming = urlParam('gwp');

  if (incoming !== null) log('param gwp en la URL: "' + incoming + '" (esperado "' + PARAM + '")');

  if (incoming === PARAM) {
    writeFlag(FLAG_KEY, '1');

    // Confirmamos leyendo de vuelta: writeFlag se traga los errores, así que
    // sin esta relectura el log diría "guardado" incluso cuando no se guardó.
    if (readFlag(FLAG_KEY) === '1') {
      log('param correcto, flag guardada en sessionStorage');
    } else {
      log('param correcto PERO la flag no se pudo guardar: sessionStorage no está escribiendo');
    }
  }

  /*==========================================================================
    Mensaje del buy box

    El bloque 'gwp_message' de main-product.liquid se renderiza siempre oculto:
    la flag vive en sessionStorage, así que Liquid no puede saber si la sesión
    viene de la campaña. Revelarlo desde aquí deja el mensaje invisible para el
    tráfico normal sin que el bloque tenga que saber nada de la promoción, y
    hereda gratis las salidas tempranas de arriba: promo apagada, config
    incompleta o vencida significa que este código nunca corre.
  ==========================================================================*/

  // En el editor de temas no hay flag de sesión, así que el mensaje sería
  // invisible y no habría forma de colocar el bloque. Ahí se muestra siempre;
  // designMode sólo existe dentro del editor.
  var designMode = !!(window.Shopify && Shopify.designMode);

  // El mensaje promete un regalo que sólo llega si el script puede agregarlo,
  // así que la condición es exactamente canAdd(): el cliente quitó la bolsa a
  // mano, el cupón dejó de descontarla, o nos rendimos tras varios fallos. El
  // producto de regalo está unlisted, así que una vez fuera del carrito el
  // cliente no tiene cómo volver a agregarlo y el mensaje sería una mentira.
  function messagesShouldShow() {
    if (designMode) return true;
    if (!PUBLIC && readFlag(FLAG_KEY) !== '1') return false;
    return canAdd();
  }

  function syncMessages() {
    var show = messagesShouldShow();
    var nodes = document.querySelectorAll('[data-gwp-message]');
    var changed = false;

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('is-visible') === show) continue;

      if (show) nodes[i].classList.add('is-visible');
      else nodes[i].classList.remove('is-visible');

      changed = true;
    }

    if (changed) log('mensaje del regalo: ' + (show ? 'visible' : 'oculto'));
  }

  syncMessages();

  // El tema repinta la sección en el editor y después de cargar los productos
  // complementarios. Volver a sincronizar es idempotente.
  document.addEventListener('shopify:section:load', syncMessages);

  // En modo público no hay nada que verificar sobre el origen. Con el modo
  // apagado, sin el flag la sesión nunca vino de la campaña: no instalamos el
  // enganche ni pedimos el carrito, y el resto del tráfico no paga nada.
  if (PUBLIC) {
    log('modo público: el regalo aplica a todos, sin importar de dónde vienen');
  } else if (readFlag(FLAG_KEY) !== '1') {
    log('sin flag: esta sesión no vino de la campaña, salgo sin instalar nada');
    return;
  }

  log('estado inicial', state());

  function canAdd() {
    if (readFlag(OPT_OUT_KEY) === '1') {
      log('opt-out activo: el cliente quitó el regalo antes, no lo devuelvo');
      return false;
    }
    if (givenUp()) {
      log('me rendí tras ' + failureCount() + ' fallos, no reintento en esta sesión');
      return false;
    }
    if (readFlag(NO_DISCOUNT_KEY) === '1') {
      log('el regalo ya entró una vez sin descuento: no lo vuelvo a agregar hasta que el cupón regrese');
      return false;
    }
    return !expired();
  }

  /*==========================================================================
    Carrito
  ==========================================================================*/

  function cartFetch(url, body) {
    var options = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      }
    };

    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    if (body) log('-> POST ' + url, body);

    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        log('<- ' + url + ' falló con status ' + response.status);
        throw response;
      }
      return response.json();
    });
  }

  function getCart() {
    return cartFetch('/cart.js');
  }

  function findGiftLine(cart) {
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      if (items[i].properties && items[i].properties[PROPERTY]) return items[i];
    }

    return null;
  }

  // El cupón puede dejar de aplicar por muchas razones ajenas al tema: el
  // cliente lo quita desde el cajón de UpCart, ya lo canjeó antes y el límite
  // "1 por cliente" lo bloquea, o venció en el admin. En todos esos casos la
  // bolsa se quedaría cobrándose a precio completo, así que preguntamos por el
  // monto y no por la existencia de la allocation: Shopify le cuelga una
  // allocation de importe 0 a la línea que sólo dispara la promoción.
  function lineHasDiscount(line) {
    if (!line) return false;
    if (line.total_discount > 0) return true;

    var allocations = line.line_level_discount_allocations || [];

    for (var i = 0; i < allocations.length; i++) {
      if (allocations[i].amount > 0) return true;
    }

    return false;
  }

  // La pregunta correcta es "¿la promoción entregó una bolsa gratis?", no
  // "¿mi línea es la descontada?". Shopify decide a cuál línea le asigna la
  // allocation, y si el cliente agregó la bolsa por su cuenta puede tocarle a
  // la suya y no a la nuestra. Preguntar por línea nos hacía retirar el regalo
  // y bloquearlo el resto de la sesión aunque la promoción sí se hubiera
  // cumplido. Por producto, el resultado es el que la promoción promete: el
  // cliente se queda con la que compró y con una gratis.
  function giftPromotionApplied(cart) {
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var isGiftProduct = GIFT_PRODUCT_ID
        ? items[i].product_id === GIFT_PRODUCT_ID
        : items[i].properties && items[i].properties[PROPERTY];

      if (isGiftProduct && lineHasDiscount(items[i])) return true;
    }

    return false;
  }

  function hasQualifyingItem(cart) {
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      // La línea del regalo nunca cuenta como producto que califica, aunque
      // el mismo producto esté en la lista de Personalizar tema.
      if (items[i].properties && items[i].properties[PROPERTY]) continue;
      if (QUALIFYING_IDS.indexOf(items[i].product_id) !== -1) return true;
    }

    return false;
  }

  /*==========================================================================
    Reconciliación

    Identificamos nuestra línea por la property _gwp y no por variant id: el
    tema selecciona líneas con .item_<variant_id> en adjustQty, así que si la 
    bolsa también se vende por separado habría dos líneas indistinguibles.

    /cart/change.js recibe la línea por key en lugar de por índice, que es
    inmune a que el orden del carrito cambie entre la lectura y la escritura.
  ==========================================================================*/

  function reconcile(cart) {
    var giftLine = findGiftLine(cart);
    var qualifies = hasQualifyingItem(cart);

    log('carrito', {
      items: (cart.items || []).length,
      califica: qualifies,
      regaloEnCarrito: giftLine ? giftLine.key : null,
      cantidadRegalo: giftLine ? giftLine.quantity : 0,
      // /cart.js expone los códigos de la sesión: es la forma directa de ver
      // si el cupón sigue aplicado sin adivinar por los precios.
      cupones: cart.discount_codes || [],
      promocionAplicada: giftPromotionApplied(cart)
    });

    // Cuando el carrito deja de calificar se cierra el episodio: limpiamos el
    // opt-out para que si el cliente vuelve a agregar un producto que califica
    // el regalo regrese. Sin esto, quitar el regalo una vez lo bloqueaba el
    // resto de la sesión, incluso después de vaciar el carrito y empezar de
    // nuevo. El opt-out sólo debe sobrevivir mientras el carrito califica.
    if (!qualifies && readFlag(OPT_OUT_KEY) === '1') {
      clearFlag(OPT_OUT_KEY);
      log('el carrito dejó de calificar: limpio el opt-out, el regalo puede volver');
    }

    if (!qualifies && readFlag(NO_DISCOUNT_KEY) === '1') {
      clearFlag(NO_DISCOUNT_KEY);
      log('el carrito dejó de calificar: limpio la marca de "sin descuento"');
    }

    // Ya no califica: la quitamos aunque el cliente hubiera pedido no verla.
    // Dejarla significaría cobrarle una bolsa que el cupón ya no descuenta.
    if (giftLine && !qualifies) {
      log('decisión: QUITAR el regalo, el carrito ya no califica');
      return cartFetch('/cart/change.js', {
        id: giftLine.key,
        quantity: 0
      }).then(function () {
        clearFlag(ADDED_KEY);
        log('regalo quitado');
        return true;
      });
    }

    // Sigue calificando pero el cupón no cayó en la bolsa: la retiramos antes
    // de que el cliente pague completo algo que se le ofreció gratis. La flag
    // evita el ciclo agregar/quitar; se limpia si el cupón regresa o si el
    // carrito deja de calificar.
    if (giftLine && qualifies && !giftPromotionApplied(cart)) {
      log('decisión: QUITAR el regalo, el cupón no está aplicándole descuento');
      return cartFetch('/cart/change.js', {
        id: giftLine.key,
        quantity: 0
      }).then(function () {
        clearFlag(ADDED_KEY);
        writeFlag(NO_DISCOUNT_KEY, '1');
        log('regalo retirado por falta de descuento');
        return true;
      });
    }

    // El cupón Buy X Get Y descuenta una sola unidad: las demás se cobran a
    // precio normal. Regresamos la cantidad a 1 para que nadie pague de más.
    if (giftLine && giftLine.quantity > 1) {
      log('decisión: BAJAR cantidad del regalo de ' + giftLine.quantity + ' a 1');
      return cartFetch('/cart/change.js', {
        id: giftLine.key,
        quantity: 1
      }).then(function () {
        log('cantidad corregida a 1');
        return true;
      });
    }

    if (!giftLine && qualifies) {
      // La habíamos agregado y ya no está mientras el carrito sigue
      // calificando: el cliente la quitó a mano. Respetamos la decisión en
      // lugar de devolverla en cada cambio del carrito.
      if (readFlag(ADDED_KEY) === '1') {
        writeFlag(OPT_OUT_KEY, '1');
        clearFlag(ADDED_KEY);
        log('decisión: el cliente quitó el regalo a mano -> opt-out, no lo devuelvo');
        return Promise.resolve(false);
      }

      if (!canAdd()) return Promise.resolve(false);

      var payload = { id: VARIANT_ID, quantity: 1, properties: {} };
      payload.properties[PROPERTY] = PARAM;

      log('decisión: AGREGAR el regalo');

      return cartFetch('/cart/add.js', payload).then(function () {
        writeFlag(ADDED_KEY, '1');
        log('regalo agregado con ' + PROPERTY + ' = "' + PARAM + '"');
        return true;
      });
    }

    log('decisión: nada que hacer, el carrito ya está correcto');
    return Promise.resolve(false);
  }

  /*==========================================================================
    Render

    Reusamos el updateView original del tema para repintar el carrito y el
    contador del header. Llamamos al original y no al envuelto, para que un
    repintado no vuelva a disparar la reconciliación.
  ==========================================================================*/

  var themeUpdateView = null;
  var running = false;

  function themeCartConfig() {
    var element = document.getElementById('cart-config');
    if (!element) return null;

    try {
      return JSON.parse(element.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function render(cart) {
    // UpCart es el carrito visible de esta tienda: su cajón es lo que el
    // cliente ve, así que refrescarlo es lo que más importa. upcartRefreshCart
    // arranca como stub y se reemplaza cuando UpCart monta, de ahí el typeof.
    try {
      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
        log('upcartRefreshCart() llamado');
      } else {
        log('window.upcartRefreshCart no está disponible todavía');
      }
    } catch (error) {
      log('upcartRefreshCart falló', error);
    }

    // El tema sigue pintando el contador del header y la página de carrito.
    var cartConfig = themeCartConfig();

    if (!themeUpdateView || !cartConfig) return;

    try {
      themeUpdateView.call(Shopify.theme.ajaxCart, cartConfig, cart);
      log('carrito del tema repintado');
    } catch (error) {
      log('el repintado del tema falló, el carrito ya está correcto', error);
    }
  }

  // Varias fuentes pueden disparar la reconciliación y UpCart emite más de un
  // evento por mutación, así que coalescemos: la última gana y sólo se hace
  // una lectura de /cart.js. El tope corta cualquier bucle patológico.
  var MAX_RECONCILES = 25;
  var reconcileCount = 0;
  var pendingTimer = null;

  function scheduleReconcile(reason, delay) {
    if (expired() || givenUp()) return;

    if (reconcileCount >= MAX_RECONCILES) {
      log('tope de ' + MAX_RECONCILES + ' reconciliaciones alcanzado en esta página, me detengo');
      return;
    }

    if (pendingTimer) clearTimeout(pendingTimer);

    pendingTimer = setTimeout(function () {
      pendingTimer = null;
      reconcileCount += 1;
      log('reconciliando por: ' + reason);

      getCart()
        .then(sync)
        .catch(function (error) {
          recordFailure();
          log('no pude leer /cart.js', error);
        });
    }, delay);
  }

  // Cada mutación puede habilitar la siguiente decisión: al agregar la bolsa
  // recién ahí se sabe si el cupón le aplicó descuento. Por eso iteramos hasta
  // que reconcile() no reporte cambios, en vez de parar tras la primera
  // mutación: si esperáramos al próximo evento, el cliente podría irse a
  // checkout con la bolsa cobrada. reconcile() converge —cada decisión acerca
  // el carrito al estado correcto y las flags impiden deshacer lo hecho— y el
  // tope de pasadas es la red por si alguna vez dejara de converger.
  var MAX_PASSES = 4;

  function step(cart, pass) {
    reconcile(cart)
      .then(function (changed) {
        if (!changed) {
          running = false;
          syncMessages();
          // Sólo repintamos si alguna pasada anterior tocó el carrito.
          if (pass > 0) render(cart);
          return null;
        }

        return getCart().then(function (freshCart) {
          if (pass + 1 >= MAX_PASSES) {
            running = false;
            syncMessages();
            log('tope de ' + MAX_PASSES + ' pasadas de reconciliación, me detengo');
            render(freshCart);
            return null;
          }

          return step(freshCart, pass + 1);
        });
      })
      .catch(function (error) {
        // Si el add o el change fallan, el carrito se queda como estaba: no
        // escribimos ADDED_KEY, así que no hay estado inconsistente.
        recordFailure();
        running = false;
        log('fallo ' + failureCount() + ' de ' + MAX_FAILURES + ', el carrito quedó intacto', error);
      });
  }

  function sync(cart) {
    if (running) {
      log('ya hay una reconciliación en curso, ignoro esta');
      return;
    }
    if (expired() || !cart || !cart.items) return;

    running = true;
    step(cart, 0);
  }

  /*==========================================================================
    Enganche

    Los siete call sites del tema invocan updateView como propiedad de
    Shopify.theme.ajaxCart, nunca por referencia capturada, así que envolver
    el método intercepta todas las mutaciones sin editar theme.js.
  ==========================================================================*/

  function install() {
    var ajaxCart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;

    if (!ajaxCart || typeof ajaxCart.updateView !== 'function') return false;
    if (ajaxCart.updateView.gwpWrapped) return true;

    var original = ajaxCart.updateView;
    themeUpdateView = original;

    function wrapped(cartConfig, cart) {
      var result = original.call(this, cartConfig, cart);
      scheduleReconcile('updateView del tema', 150);
      return result;
    }

    wrapped.gwpWrapped = true;
    ajaxCart.updateView = wrapped;
    log('enganche instalado en Shopify.theme.ajaxCart.updateView');

    return true;
  }

  if (!install()) {
    // gwp-config se renderiza después de theme.js, así que install() debería
    // pasar en el primer intento. Esta espera acotada cubre el caso de que
    // algo reordene los scripts; no es un polling del carrito.
    log('Shopify.theme.ajaxCart no existe todavía, espero hasta 5s');

    var attempts = 0;

    var timer = setInterval(function () {
      attempts += 1;

      if (install() || attempts >= 20) {
        clearInterval(timer);
        if (attempts >= 20) log('me rendí esperando Shopify.theme.ajaxCart');
      }
    }, 250);
  }

  // El tema reinicia el carrito en shopify:section:load y después de cargar
  // los productos complementarios. init() no reasigna updateView, pero
  // install() es idempotente y así el enganche sobrevive de cualquier forma.
  document.addEventListener('shopify:section:load', install);

  /*==========================================================================
    Eventos públicos de UpCart

    Son CustomEvents en window, así que los escuchamos por nombre y no
    dependemos de que el bundle de UpCart ya haya cargado ni de que sus
    helpers upcartSubscribe* existan todavía.

    Esta es la única fuente que cubre lo que pasa DENTRO del cajón de UpCart
    —quitar una línea, cambiar cantidad—, porque nada de eso pasa por el
    updateView del tema.
  ==========================================================================*/

  var UPCART_EVENTS = [
    'aftersell-upcart:public-events:added-to-cart',
    'aftersell-upcart:public-events:cart-updated',
    'aftersell-upcart:public-events:item-removed',
    'aftersell-upcart:public-events:cart-loaded',
    'aftersell-upcart:public-events:cart-opened'
  ];

  UPCART_EVENTS.forEach(function (name) {
    window.addEventListener(name, function () {
      scheduleReconcile('evento de UpCart ' + name.split(':').pop(), 200);
    });
  });

  // UpCart deja que el cliente quite el cupón desde el cajón (removeDiscountCode)
  // y avisa con estos dos eventos. Quitarlo deja la bolsa a precio completo, así
  // que hay que reaccionar. Si lo vuelve a aplicar, limpiamos la marca para que
  // el regalo pueda regresar.
  window.addEventListener('upcart:discount-remove', function () {
    scheduleReconcile('el cliente quitó el cupón', 300);
  });

  window.addEventListener('upcart:discount-apply', function () {
    clearFlag(NO_DISCOUNT_KEY);
    log('cupón aplicado: limpio la marca de "sin descuento"');
    scheduleReconcile('el cliente aplicó un cupón', 300);
  });

  /*==========================================================================
    Click en add to cart, en fase de captura

    UpCart mata el handler del tema con stopImmediatePropagation(), pero eso
    sólo afecta la fase de burbujeo. En captura sobre document corremos antes
    y nos enteramos del add aunque el tema nunca lo vea. El retraso deja que
    la mutación llegue al servidor; si tarda más, el evento de UpCart cubre.
  ==========================================================================*/

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var trigger = target.closest(
        '[name="add"], .js-ajax-submit, [data-add-to-cart], form[action*="/cart/add"] [type="submit"]'
      );

      if (!trigger) return;

      scheduleReconcile('click en add to cart', 900);
    },
    true
  );

  /*==========================================================================
    Utilidades de debug — sólo existen con gwp_debug=1
  ==========================================================================*/

  if (DEBUG) {
    window.GWP = {
      state: state,
      reset: function () {
        clearFlag(FLAG_KEY);
        clearFlag(ADDED_KEY);
        clearFlag(OPT_OUT_KEY);
        clearFlag(FAILURES_KEY);
        clearFlag(NO_DISCOUNT_KEY);
        log('flags borradas (debug sigue encendido). Recarga con ?gwp=' + PARAM + ' para volver a empezar.');
        return state();
      },
      clearCart: function () {
        return cartFetch('/cart/clear.js', {}).then(function () {
          log('carrito vaciado, recargando');
          window.location.reload();
        });
      },
      cart: getCart
    };

    log('window.GWP disponible: state(), reset(), clearCart(), cart()');
  }

  /*==========================================================================
    Arranque

    updateView no se dispara solo en páginas que no son el carrito, y el
    correo aterriza en una colección. Este chequeo cubre esa carga y las
    rutas sin JS del tema, que recargan la página completa.
  ==========================================================================*/

  if (givenUp()) {
    log('arranque: me rendí tras ' + failureCount() + ' fallos, no pido el carrito');
  } else {
    scheduleReconcile('carga de página', 0);
  }
})();
